import Select from "@material-ui/core/esm/Select";
import MenuItem from "@material-ui/core/esm/MenuItem";
import FormControl from "@material-ui/core/esm/FormControl";
import { nanoid } from 'nanoid';
import React, { useState, useEffect } from 'react';
import { BoldSubtitle } from 'components/Text';
import useStyles from './FormStyles';
const idSuffix = nanoid();
export default function SelectComponent({
  id,
  items,
  defaultItem,
  label,
  onChange
}) {
  const [selected, setSelected] = useState(defaultItem);
  const {
    select
  } = useStyles();
  useEffect(() => {
    if (defaultItem) {
      setSelected(defaultItem);
      onChange(defaultItem);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleChange = event => {
    const e = event.target;
    setSelected(e.value);
    onChange(e.value);
  };
  const labelId = `${label}_${idSuffix}`;
  return /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    className: select
  }, /*#__PURE__*/React.createElement(BoldSubtitle, {
    id: labelId
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, label)), /*#__PURE__*/React.createElement(Select, {
    labelId: id,
    id: id,
    value: selected,
    onChange: handleChange,
    variant: "outlined",
    defaultValue: defaultItem,
    disabled: !items?.length
  }, items?.map(({
    value,
    label: itemLabel
  }) => /*#__PURE__*/React.createElement(MenuItem, {
    key: value,
    value: value
  }, itemLabel))));
}
SelectComponent.defaultProps = {
  defaultItem: ''
};